import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.17.1_@electric-sql+pglite@0.2.9_@parcel+watcher@2.4.1_@types+node@20.11.30_db0@0_38de638c43d2674c9138c340c50d5756/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}